<div class="popup_background" [ngClass]="shown ? 'shown' : ''" (mousedown)="closeEvent.emit()">
  <div class="popup_container" (mousedown)="$event.stopPropagation()">
    <fa-icon (click)="closeEvent.emit(); $event.stopPropagation()" [style.color]="closeIconColor" style="position: absolute; top:2px; right: 4px; cursor: pointer; border-radius: 4px;" [icon]="faWindowClose"></fa-icon>
    <div style="max-height: 800px; overflow: auto;">
      <ng-content></ng-content>
    </div>
  </div>
</div>
